var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoDinein = function SvgIcoDinein(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (/*#__PURE__*/React.createElement("svg", _extends({
      width: 48,
      height: 48,
      viewBox: "0 0 48 48",
      fill: "none",
      ref: svgRef
    }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M29 14V26H34V40.5C34 40.8978 34.158 41.2794 34.4393 41.5607C34.7206 41.842 35.1022 42 35.5 42C35.8978 42 36.2794 41.842 36.5607 41.5607C36.842 41.2794 37 40.8978 37 40.5V6C34.8783 6 32.8434 6.84285 31.3431 8.34315C29.8429 9.84344 29 11.8783 29 14Z",
      fill: "currentColor"
    })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
      d: "M22 16H19V6H16V16H13V6H10V16.5C10.0071 18.227 10.6069 19.8992 11.699 21.237C12.7911 22.5749 14.3094 23.4973 16 23.85V40.51C16.0026 40.9061 16.1618 41.2851 16.4429 41.5642C16.7239 41.8433 17.1039 42 17.5 42C17.8978 42 18.2794 41.842 18.5607 41.5607C18.842 41.2794 19 40.8978 19 40.5V23.85C20.6906 23.4973 22.2089 22.5749 23.301 21.237C24.3931 19.8992 24.9929 18.227 25 16.5V6H22V16Z",
      fill: "currentColor"
    })))
  );
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (/*#__PURE__*/React.createElement(SvgIcoDinein, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ico_dinein.3a303a75.svg";
export { ForwardRef as ReactComponent };